import { useEffect, useState } from 'react';
import axios from 'axios';
import { PLANS } from '../config/plans';

// The plan list with today's prices: config/plans.js first, then the live
// amounts from GET /api/plans laid over it once that call succeeds.
//
// The static list is what renders first and what scripts/prerender.js bakes
// into the pre-rendered HTML (the pre-render aborts every request off its own
// origin, so this call fails there and nothing is replaced). A price changed
// from the Platform Admin page therefore shows on load in a browser, while
// the HTML a crawler reads keeps the static default until config/plans.js
// and public/llms.txt are updated. The admin Plan pricing card says when
// those have drifted.
//
// Only the price is taken from the server. A failed call, or a response that
// is not four sane amounts, leaves the static list as it is.

// The static plans with each live amount laid over, or null when the
// response is unusable.
export const mergeLivePrices = (staticPlans, livePlans) => {
  if (!Array.isArray(livePlans)) return null;
  const byId = new Map(livePlans.map((p) => [p && p.id, p]));
  const merged = [];
  for (const plan of staticPlans) {
    const live = byId.get(plan.id);
    const cents = live && live.amountCents;
    if (!Number.isInteger(cents) || cents <= 0) return null;
    merged.push({ ...plan, price: cents / 100 });
  }
  return merged;
};

export default function useLivePlans() {
  const [plans, setPlans] = useState(PLANS);

  useEffect(() => {
    let cancelled = false;
    // Wrapped so that nothing axios.get does, returning or throwing, can
    // reach the page: the static list simply stays.
    Promise.resolve()
      .then(() => axios.get(`${process.env.REACT_APP_API_URL}/api/plans`))
      .then((res) => {
        const merged = mergeLivePrices(PLANS, res && res.data && res.data.plans);
        if (!cancelled && merged) setPlans(merged);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return plans;
}
